<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:00em; padding-top:15px; ">For my Mother who inspired me to be humble and a kind human being. Her life and her love were for ‘her three boys’ a legacy which has continued for us all too.</p>
<p style="text-indent:00em; padding-top:15px; ">For Lynne, Gary and Nicky who have inspired me directly and indirectly, each in their own special way, to write this book.</p>
<p style="text-indent:00em; padding-top:15px; ">For Chester who had a battle from birth, will have battles throughout his life, but I know will grow to be a remarkable and kind person.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7a58535f